import React, { useContext } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Container } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import HomeSlider from '../../Home/HomeSlider/HomeSlider';
import HomeContext from '../../../routes/context/homeContext';
import Link from '../../Link/Link';
import messages from '../../../locale/messages';
import { getDynamicTitleByLocale, getDynamicTitleByName } from '../../../helpers/getDynamicTitle';
import bt from '../../commonStyle.css';
import s from './CitySection.css';


const CitySection = ({ data, currentLocale, dynamicHomePageSettings }) => {
  const homepage = useContext(HomeContext); // If needed later

  const allCategoryTitle = getDynamicTitleByName({ dynamicHomePageSettings, name: 'citySectionTitle1' });
  let categoryTitle = getDynamicTitleByLocale({ dynamicHomePageSettings: allCategoryTitle, locale: currentLocale });
  categoryTitle = categoryTitle?.length > 0 ? categoryTitle[0] : allCategoryTitle[0];

  return (
    <div className={s.categoryBgWrapper}>
      <Container>
        <h2 className={s.categorySliderHeading}>{categoryTitle?.value}</h2>
        <HomeSlider data={data} />
        <div className={s.viewAllLinkContainer}>
          <Link to={"/category?type=all"} className={bt.viewAllLink} ><FormattedMessage {...messages.viewAll} /></Link>
        </div>
      </Container>
    </div>
  );

};

export default withStyles(bt, s)(CitySection);
